import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { ContentDataSources, ContentDataSourcesVariables } from './__generated__/ContentDataSources';

const CONTENT_DATA_SOURCES_QUERY = gql`
  query ContentDataSources($search: String!, $first: Int) {
    contentDataSources(search: $search, first: $first) {
      edges {
        node {
          id
          name
          path
          dataSourceType
        }
      }
    }
  }
`;

export const useContentDataSources = () => {
  return useLazyQuery<ContentDataSources, ContentDataSourcesVariables>(CONTENT_DATA_SOURCES_QUERY, {
    client: kmsClient
  });
};
